import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import EthiquinInspector0 from "../../../assets/images/Ethiquin/1.png";
import EthiquinInspector1 from "../../../assets/images/Ethiquin/2.png";
import EthiquinInspector2 from "../../../assets/images/Ethiquin/3.png";
import EthiquinInspector3 from "../../../assets/images/Ethiquin/4.png";
import EthiquinInspector4 from "../../../assets/images/Ethiquin/5.png";
import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import { EGButton } from "../../MainComponents/Button/EGButton/EGButton";
import { EGInput } from "../../MainComponents/Input/EGInput";
import { EGIconButton } from "../../MainComponents/Button/IconButton/IconButton";
import { ReactComponent as EthiquinProgress } from "../../../assets/images/Ethiquin/ethiqun-progress.svg";
import { ReactComponent as EthiquinMegaphone } from "../../../assets/images/Ethiquin/alerta_robot.svg";
import { ReactComponent as EthiquinNoData } from "../../../assets/images/Ethiquin/ethiquin_no_data.svg";
import { ReactComponent as EthiquinInvestigation } from "../../../assets/images/Ethiquin/ethiquin-investigation.svg";
import "./Confirmation.scss";

/**
 * @param {string} variant ["light", "primary", "secondary", "success", "error", "warning", info ]
 */

export const Confirmation = ({
  show,
  onHide,
  size = "lg",
  title = "",
  titleColor = "secondary",
  description1 = "",
  description2 = "",
  question = "",
  variant = "light",
  buttonSize = "small",
  loading = false,
  // Button Left
  leftButtonText = "Left",
  leftButtonColor = "secondary",
  leftButtonVariant = "",
  leftButtonLabelColor = "",
  leftIconName = "",
  leftIconColor = "",
  leftIconColorHover = "",
  onClickLeft,
  // Button Right
  rightButtonText = "Right",
  rightButtonColor = "primary",
  rightButtonVariant = "",
  rightButtonLabelColor = "",
  rightIconName = "",
  rightIconColor = "",
  rightIconColorHover = "",
  onClickRight,
  ethiquin = "investigation",
  // Input opcional (motivo, nombre, etc.). Controlado si llega setInputValue;
  // si no, el valor vive aquí y se entrega como argumento a onClickRight.
  inputLabel = "",
  inputValue = "",
  setInputValue,
  inputMultiline = false,
  inputRows = 3,
}) => {
  const theme = useTheme();
  const [innerValue, setInnerValue] = useState("");

  // Cada apertura empieza con el input limpio
  useEffect(() => {
    if (show) setInnerValue("");
  }, [show]);

  const isControlled = typeof setInputValue === "function";
  const currentInput = isControlled ? inputValue : innerValue;

  const hasDescriptions = description1 || description2;
  const hasQuestion = question;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={size}
      className={`confirmation-modal ${variant}`}
    >
      <Modal.Body className="p-0">
        {/* Close button */}
        <EGIconButton
          iconName="cancel_circle"
          onClick={onHide}
          iconColor="primary"
          sx={{ position: "absolute", top: 6, right: 6 }}
        />
        <Grid2 container>
          <Grid2
            size={{ xs: "auto", sm: 4 }}
            display={{ xs: "none", sm: "flex" }}
            alignItems="center"
            justifyContent="center"
            py={2}
          >
            {ethiquin === "progress" && (
              <EthiquinProgress style={{ margin: "auto" }} />
            )}
            {ethiquin === "megaphone" && (
              <EthiquinMegaphone style={{ margin: "auto", padding: "15px" }} />
            )}
            {ethiquin === "nodata" && (
              <EthiquinNoData style={{ margin: "auto", padding: "15px" }} />
            )}
            {ethiquin === "investigation" && (
              <EthiquinInvestigation
                style={{ margin: "auto", padding: "15px" }}
              />
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 8 }} p={3}>
            <Stack
              display="flex"
              justifyContent={
                hasDescriptions || hasQuestion ? "space-between" : "center"
              }
              spacing={1.75}
              height="100%"
              mx="auto"
            >
              {/* Title */}
              {title && (
                <Typography
                  variant="h3"
                  color={titleColor || theme.palette.secondary.main}
                  mb={!hasDescriptions ? 2 : null}
                  fontWeight={600}
                  mt={1}
                >
                  <b>{title}</b>
                </Typography>
              )}
              {/* Description(s) */}
              {hasDescriptions && (
                <Stack spacing={2}>
                  {description1 && (
                    <Typography variant="body1" component="span">
                      {description1}
                    </Typography>
                  )}
                  {description2 && (
                    <Typography variant="body1" component="span">
                      {description2}
                    </Typography>
                  )}
                </Stack>
              )}

              {/* Optional input */}
              {inputLabel && (
                <EGInput
                  label={`${inputLabel}:`}
                  value={currentInput}
                  onChange={(e) =>
                    isControlled
                      ? setInputValue(e.target.value)
                      : setInnerValue(e.target.value)
                  }
                  multiline={inputMultiline}
                  rows={inputMultiline ? inputRows : undefined}
                />
              )}

              {/* Question */}
              {hasQuestion && (
                <Typography variant="small" color="primary" component="div">
                  {question}
                </Typography>
              )}

              {/* Action Buttons */}
              <Box
                display="flex"
                justifyContent="space-evenly"
                alignItems="center"
                gap={2}
                my={0.5}
              >
                <EGButton
                  label={leftButtonText}
                  onClick={onClickLeft ? onClickLeft : onHide}
                  color={leftButtonColor}
                  size={buttonSize}
                  labelColor={leftButtonLabelColor}
                  variant={leftButtonVariant}
                  loading={loading}
                  sx={{ minWidth: "40%" }}
                  iconName={leftIconName}
                  iconColor={leftIconColor}
                  iconColorHover={leftIconColorHover}
                />
                <EGButton
                  label={rightButtonText}
                  // El texto capturado viaja como argumento; los callbacks que
                  // no esperan nada lo ignoran sin problema
                  onClick={
                    onClickRight ? () => onClickRight(currentInput) : onHide
                  }
                  color={rightButtonColor}
                  size={buttonSize}
                  labelColor={rightButtonLabelColor}
                  variant={rightButtonVariant}
                  loading={loading}
                  sx={{ minWidth: "40%" }}
                  iconName={rightIconName}
                  iconColor={rightIconColor}
                  iconColorHover={rightIconColorHover}
                />
              </Box>
            </Stack>
          </Grid2>
        </Grid2>
      </Modal.Body>
    </Modal>
  );
};

/**
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @param {string} params.variant ["light", "primary", "secondary", "success", "error", "warning", info ]
 * @param {string} params.ethiquin ["inspector", "progress", "megaphone", "nodata", "investigation"]
 * @param {string} params.size ["sm", "md", "lg", "xl"]
 * @param {boolean} params.show
 * @param {function} params.onHide
 */

export const ConfirmationContainer = ({
  show,
  onHide,
  size = "lg",
  variant = "light",
  ethiquin = "inspector",
  sx = {},
  children,
}) => {
  const [currentEtiquinIdx, setCurrentEtiquinIdx] = useState(0);
  const isForwardRef = useRef(true);

  const ethiquines = [
    EthiquinInspector0,
    EthiquinInspector1,
    EthiquinInspector2,
    EthiquinInspector3,
    EthiquinInspector4,
  ];

  // Animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentEtiquinIdx((prevIdx) => {
        if (isForwardRef.current) {
          if (prevIdx === ethiquines.length - 1) {
            isForwardRef.current = false;
            return prevIdx - 1;
          }
          return prevIdx + 1;
        } else {
          if (prevIdx === 0) {
            isForwardRef.current = true;
            return prevIdx + 1;
          }
          return prevIdx - 1;
        }
      });
    }, 250);

    return () => clearInterval(interval);
  }, [ethiquines.length]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={size}
      className={`confirmation-modal ${variant}`}
    >
      <Modal.Body className="p-0">
        {/* Close button */}
        <EGIconButton
          iconName="cancel_circle"
          onClick={onHide}
          iconColor="primary"
          sx={{ position: "absolute", top: 6, right: 6 }}
        />
        <Grid2 container>
          <Grid2
            size={{ xs: "auto", sm: 4 }}
            display={{ xs: "none", sm: "flex" }}
            alignItems="center"
            justifyContent="center"
            py={2}
          >
            {ethiquin === "inspector" && (
              <img
                src={ethiquines[currentEtiquinIdx]}
                alt={`Slice ${currentEtiquinIdx}`}
                className="m-auto"
                width={"100%"}
                height={"auto"}
              />
            )}
            {ethiquin === "progress" && (
              <EthiquinProgress style={{ margin: "auto" }} />
            )}
            {ethiquin === "megaphone" && (
              <EthiquinMegaphone style={{ margin: "auto", padding: "15px" }} />
            )}
            {ethiquin === "nodata" && (
              <EthiquinNoData style={{ margin: "auto", padding: "15px" }} />
            )}
            {ethiquin === "investigation" && (
              <EthiquinInvestigation
                style={{ margin: "auto", padding: "15px" }}
              />
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 8 }} sx={{ ...sx }}>
            {children}
          </Grid2>
        </Grid2>
      </Modal.Body>
    </Modal>
  );
};
